<section
  [ngClass]="{
    host: !getCanShowNeedRepair,
    'claim-2-0-host': getCanShowNeedRepair
  }"
>
  <section
    *ngIf="!isLoading"
    class="title-wrapper"
    [ngClass]="{
      'title--devider': !isNonActiveState
    }"
  >
    <h3 class="typog-h3" *ngIf="!getCanShowNeedRepair">
      {{
        (isRPC
          ? 'MMR.REPLACEMENT.TITLE'
          : 'MMR.SECTION.' + claimType + '.TITLE'
        ) | translate
      }}
    </h3>

    <!-- TODO: Bring this back when designs have been updated -->
    <!-- <div *ngIf="claimDetails?.excessPaid" class="excess-paid-badge">
    Excess paid
    <dgx-components-icon name="check"> </dgx-components-icon>
  </div> -->
  </section>

  <ng-container *ngIf="!isLoading; else Loader">
    <section
      class="need-a-repair-container"
      *ngIf="getCanShowNeedRepair"
      style="width: 100%"
    >
      <claims-repair-need-a-repair
        #needARepairComponent
        [claimType]="claimType"
        [mmrItem]="fullClaimsDetails.item"
        [claim]="fullClaimsDetails"
        [correspondenceAddress]="address"
        [claimTypes]="claimTypes"
        [inWarranty]="
          fullClaimsDetails.planInWarrantyPeriod ||
          fullClaimsDetails.repairAction === 'IN_WARRANTY'
        "
        [planInWarrantyContactName]="
          fullClaimsDetails.planInWarrantyContactName
        "
        [planInWarrantyContactTel]="
          fullClaimsDetails.planInWarrantyContactTel ||
          fullClaimsDetails.inWarrantyContactTel
        "
        (bookRepairClicked)="isLoading = true"
        (manufacturerSelected)="selectedManufacturer = $event"
        (createClaim)="
          createClaim.emit({
            claimType: claimType,
            claimId: undefined,
            beforeBookingStage: isClaimBeforeBookingStage,
            orbitFlowData: isNewOrbitFlow
              ? {
                  planNumber: fullClaimsDetails?.planNumber,
                  currentState: action,
                  claimTypeId: needARepairComponent.selectedOption?.claimTypeID,
                  hasServiceOption: this.hasServiceDetails(),
                  claimType: claimType,
                  selectedProductType:
                    needARepairComponent.productTypeQuestionState
                      ?.selectedOption ?? undefined,
                  manufacturer: selectedManufacturer
                }
              : undefined
          })
        "
        [planInWaitPeriod]="fullClaimsDetails.planInWaitPeriod"
      ></claims-repair-need-a-repair>
    </section>

    <ng-container *ngIf="!getCanShowNeedRepair">
      <section
        *ngIf="isNonActiveState; else ActiveClaimState"
        class="claim-status-wrapper"
      >
        <claims-athome-myaccount-manage-my-repair-non-active-repair-state
          *ngIf="fullClaimsDetails"
          [fullClaimsDetails]="fullClaimsDetails"
          [item]="fullClaimsDetails.item"
          [isNewClaims]="getCanShowNeedRepair"
          [action]="action"
          [claimType]="claimType"
          [directReferral]="fullClaimsDetails.directReferral"
          [claimDisplayDetails]="claimDisplayDetails"
          [claimDetails]="claimDetails"
          [isRPC]="isRPC"
          [isNonBookableProductType]="isNonBookableProductType"
          [isSPToContactCustomerFlow]="isSPToContactCustomerFlow"
          (createClaim)="
            createClaim.emit({
              claimType: claimType,
              claimId: claimDetails?.id,
              beforeBookingStage: isClaimBeforeBookingStage,
              orbitFlowData: canUseOrbitFlow
                ? {
                    planNumber: fullClaimsDetails?.planNumber,
                    currentState: action,
                    claimTypeId: claimDetails?.claimTypeId,
                    hasServiceOption: this.hasServiceDetails(),
                    claimType: claimType,
                    claimId: claimDetails?.id,
                    manufacturer: selectedManufacturer
                  }
                : undefined
            })
          "
          (rebookClaim)="
            rebookClaim.emit({
              claimType: claimType,
              claimId: claimDetails?.id
            })
          "
          (cancelClaim)="
            cancelClaim.emit({
              claimType: claimType,
              claimId: claimDetails?.id,
              beforeBookingStage: true
            })
          "
        >
        </claims-athome-myaccount-manage-my-repair-non-active-repair-state>
      </section>
    </ng-container>

    <ng-template #ActiveClaimState>
      <claims-athome-myaccount-manage-my-repair-active-claim-details
        *ngIf="claimDetails && claimDisplayDetails?.showDetailsBreakdown"
        [claimDetails]="claimDetails"
        [claimType]="claimType"
        [displayDetails]="claimDisplayDetails"
        [fullClaimDetails]="fullClaimsDetails"
        [nextAction]="claimDetails.claimStatus"
        [action]="action"
        [callCostType]="callCostType"
        [lastUpdated]="lastUpdated"
        (rebookClaim)="
          rebookClaim.emit({
            claimType: claimType,
            claimId: claimDetails?.id
          })
        "
        (cancelClaim)="
          cancelClaim.emit({
            claimType: claimType,
            claimId: claimDetails?.id,
            beforeBookingStage: true
          })
        "
        (trackClaim)="trackClaim.emit(claimDetails?.id)"
      >
      </claims-athome-myaccount-manage-my-repair-active-claim-details>
    </ng-template>
  </ng-container>

  <ng-template #Loader>
    <claims-athome-myaccount-manage-my-repair-loading>
    </claims-athome-myaccount-manage-my-repair-loading>
  </ng-template>
</section>
